import './App.css';
import React from 'react';
import Landing from './components/Landing';
import Transform from './components/Transform';
import Experience from './components/Experience';
import FourDays from './components/FourDays';
import ButtonReserve from './components/ButtonReserve';
import Schedule from './components/Schedule';
import JoinThousands from './components/JoinThousands';
import MoreAbout from './components/MoreAbout';
import Approach from './components/Approach';
import FAQ from './components/FAQ';
import Media from './components/Media';
import Ready from './components/Ready';
import RegisterStepper from './components/registration/RegisterStepper';
import LandingFooter from './components/LandingFooter';

function App() {
  return (
    <div className="App">
      <Landing />
      <Transform />
      <Experience />
      <FourDays />
      <ButtonReserve />
      {/* <p className="text-red-600 font-bold text-base mt-3 mb-6">
        SAVE $100 - Early Bird Rate ends Dec 21
      </p> */}
      <Schedule />
      <JoinThousands />
      <MoreAbout />
      <Approach />
      <ButtonReserve />
      {/* <p className="text-red-600 font-bold text-base mt-3 mb-6">
        SAVE $100 - Early Bird Rate ends Dec 21
      </p> */}
      <FAQ />
      <Ready />
      <RegisterStepper />
      <LandingFooter />
      {/* <Media /> */}
    </div>
  );
}

export default App;
